/**
 * 时间格式yyyy-MM-dd
 */
export function  dateFormatter (date) {
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const strDate = date.getDate().toString().padStart(2, '0')
  return `${date.getFullYear()}-${month}-${strDate}`
}

/**
 * 时间格式yyyy-MM-dd HH:mm:ss
 */
export function  dateTimeFormatter (date) {
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const strDate = date.getDate().toString().padStart(2, '0')
  return `${date.getFullYear()}-${month}-${strDate} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
}

/**
 * 检查上传的文件大小是否超过阈值
 * @param vue vue实例对象
 * @param uploadObj element-ui的Upload组件
 * @param file 需检查的文件
 * @param size 文件大小阈值。个位数表示M，多位数表示KB
 * @returns {boolean}
 */
export function  checkUploadFileSize (vue, uploadObj, file, size) {
  let mUnit = 'M' // 单位是M
  if (size > 20) {
    mUnit = 'KB' // 单位是KB
  }

  let result = true
  if (mUnit === 'M') {
    if (file.size / 1024 / 1024 >= size) {
      result = false
    }
  } else {
    if (file.size / 1024 >= size) {
      result = false
    }
  }

  if (!result) {
    uploadObj.handleRemove(file)
    vue.$alert(`上传的图片/视频大小不能超过 ${ size }${ mUnit }!`, '提示', {
      confirmButtonText: '确定',
      callback: action => {

      }
    })
  }

  return result
}

/**
 * 移除上传的文件
 * @param vue vue对象
 * @param uploadObj element-ui的Upload组件
 * @param file 要移除的文件
 */
export function removeUploadFile (vue, uploadObj, file) {
  vue.$confirm(`确定移除 ${ file.name }？`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    uploadObj.handleRemove(file)
  }).catch(() => {
  })
}

/**
 * 检查上传的文件数量是否超出阈值
 * @param vue vue对象
 * @param count 文件数量阈值
 */
export function handlerUploadExceed (vue, count) {
  vue.$alert(`只能上传 ${ count } 张图片!`, '提示', {
    confirmButtonText: '确定',
    callback: action => {

    }
  })
}

/**
 * 提示Form表单上传前检查发现的错误信息
 * @param vue vue对象
 * @param errorMessage 错误信息
 */
export function alertFormSubmitMessage (vue, errorMessage) {
  vue.$alert(`${ errorMessage }`, '错误', {
    confirmButtonText: '确定',
    callback: action => {

    }
  })
}

/**
 * element-ui自定义校验器：检查手机号码格式是否正确
 * @param rule
 * @param value
 * @param callback
 * @returns {*}
 */
export const checkPhone = (rule, value, callback) => {
  const phoneReg = /^1[2|3|4|5|6|7|8|9][0-9]{9}$/
  if (!value) {
    return callback(new Error('请填写手机号码'))
  }
  setTimeout(() => {
    // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
    // 所以我就在前面加了一个+实现隐式转换
    if (!Number.isInteger(+value)) {
      callback(new Error('请输入数字值'))
    } else {
      if (phoneReg.test(value)) {
        callback()
      } else {
        callback(new Error('手机号码格式不正确'))
      }
    }
  }, 100)
}

/**
 * element-ui自定义校验器：检查身份证号码格式是否正确
 * @param rule
 * @param value
 * @param callback
 * @returns {*}
 */
export const checkIdCardNo = (rule, value, callback) => {
  const reg = /^\d{6}(19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/
  if (!value) {
    return callback(new Error('请填写身份证号码'))
  }
  setTimeout(() => {
    if (reg.test(value)) {
      callback()
    } else {
      callback(new Error('身份证号码格式不正确'))
    }
  }, 100)
}


/**
 * element-ui自定义校验器：检查邮箱格式是否正确
 * @param rule
 * @param value
 * @param callback
 * @returns {*}
 */
export const checkEmail = (rule, value, callback) => {
  // const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
  const mailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u;
  if (!value) {
    return callback(new Error('邮箱不能为空'))
  }
  setTimeout(() => {
    if (mailReg.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的邮箱格式'))
    }
  }, 100)
}

/**
 * 对数字进行格式化
 * @param num
 * @param v
 * @returns {number}
 */
export const decimalFormat = (num, v=2) => {
  var vv = Math.pow(10, v);
  return Math.round(num * vv) / vv;
}

/**
 * 对数字进行千分位格式化
 * @param num 数字
 * @returns {string} 9,000,000
 */
export const formatNumber = (num) => {
  let str = num.toString();
  let result = str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return result;
}



// WEBPACK FOOTER //
// ./src/common/utils.js